import React from 'react';

import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import { SectionState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

interface TimeFrequencyOption {
  value: string;
  label: string;
}

export default function TimeFrequencySection({
  timeFrequency, open, onToggle,
}: SectionState & {
  timeFrequency: {
    timeFrequencies: TimeFrequencyOption[];
    selectedTimeFrequency: TimeFrequencyOption | undefined;
    setTimeFrequency: (value: string) => void;
  };
}) {
  return (
    <Section
      label="Frequência temporal"
      valueText={timeFrequency.selectedTimeFrequency?.label}
      open={open}
      onToggle={onToggle}
    >
      {timeFrequency.timeFrequencies.map((tf) => (
        <OptionRow
          key={tf.value}
          label={tf.label}
          selected={tf.value === timeFrequency.selectedTimeFrequency?.value}
          onSelect={() => timeFrequency.setTimeFrequency(tf.value)}
        />
      ))}
    </Section>
  );
}
